import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconBonus = props => {
  if (props.id !== "_svgiconbonus") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><path d="M24 31l-9 6 4-10-9-6h10l4-10 4 10h10l-9 6 4 10z" fill="#384048" /></svg>;
};

SvgIconBonus.displayName = "_svgiconbonus";
SvgIconBonus.propTypes = {
  id: PropTypes.string
};
SvgIconBonus.defaultProps = {
  id: ''
};
export default SvgIconBonus;